import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * ProtectedRoute - Wrapper for routes that require authentication
 */
function ProtectedRoute({ children, user, requireAdmin = false, redirectTo = "/" }) {
  // Loading state - show nothing while checking auth
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Not authenticated
  if (!user) {
    return <Navigate to={redirectTo} replace />;
  }

  // Require admin but user is not admin
  if (requireAdmin && !user.is_admin) {
    return <Navigate to="/" replace />;
  }

  // All checks passed - render children
  return children;
}

export default ProtectedRoute;